/* eslint-disable */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import VeeValidate from 'vee-validate';
import VueLodash from 'vue-lodash';
import VueKonva from 'vue-konva';
import lodash from 'lodash';
import App from './App';
import router from './router';
import '../node_modules/vuetify/dist/vuetify.min.css';
import store from './vuex/store';
import { Validator } from 'vee-validate';
import { emailRegex } from './helper';

Vue.use(Vuetify, {
  theme: {
    primary: '#26a69a',
    secondary: '#b0bec5',
    accent: '#FF5252',
    error: '#FFA000',
  },
});

const dictionary = {
  slv: {
    messages: {
      required: (field) => `${field} je obvezno polje!`,
      date_format: (field, args) => `${field} ni pravilnega formata ${[args]}`,
      email: (field) => `${field} mora biti email!`,
    },
  },
};

Vue.use(VueKonva, { prefix: 'Konva' });

Vue.use(require('vue-moment'));

Vue.use(VueLodash, { lodash: lodash });

Vue.use(VeeValidate, {
  locale: 'slv',
  dictionary,
  delay: 50,
  events: 'blur',
  inject: true,
});

function arePartnerAndClientEqual(partner, client) {
  try {
    const partnerVatId = partner.Davcna || partner;
    const clientVatId = client.Davcna || client;

    return partnerVatId.replace(/\D/g, '') === clientVatId.replace(/\D/g, '');
  } catch (e) {
    return false;
  }
}

const isInvoice = (documentType) => documentType === 'INV' || documentType === 'IRN';

const clientAndPartnerValidator = (value, [clientOrPartner, documentType]) => {
  let valid = true;
  const documentTypeValue = documentType ? documentType.value : documentType;
  if (isInvoice(documentTypeValue)) {
    valid = !arePartnerAndClientEqual(value, clientOrPartner);
  }
  return {
    valid,
    data: {
      message: valid ? '' : 'Prejemnik in izdajatelj ne smeta biti enaka',
    },
  };
};

Validator.extend('email_array', {
  validate: (value) => {
    if (!Array.isArray(value)) return false;
    return value.every((email) => emailRegex.test(email));
  },
  getMessage: (field) => `${field} mora vsebovati veljavne email naslove!`,
});

Validator.extend('client_and_partner', {
  validate: clientAndPartnerValidator,
  getMessage: (field, params, data) => data.message,
});

Vue.config.productionTip = process.env.NODE_ENV === 'prod' || process.env.NODE_ENV === 'production';

/* eslint-disable no-new */
new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount('#app');
